import defaultValues from './default.json';
import type { LocalisationConfigWithLang } from '../types';

const config: LocalisationConfigWithLang = {
  ...defaultValues,
  distanceUnit: 'miles',
  'apprenticeship.isEnabled': true,
  'apprenticeship.hasTalentPool': true,
  'apprenticeship.agreement.url': '/p/apprenticeship-agreement',
  'page.uplift.url': '/us-apprenticeship-for-business',
  'page.policies_specific_country.url': '/p/regulatory-information',
};

export default config;
